import React from "react";
import { NavLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// Home now links externally
const pages = [
  { label: "Home", path: "https://dreamdor.com", external: true },
  { label: "Blog", path: "/blog", external: false },
];

export default function BlogNavbar() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const drawer = (
    <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
      <Box
        sx={{ width: 250 }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <List>
          {pages.map((page) =>
            page.external ? (
              <ListItem
                button
                key={page.label}
                component="a"
                href={page.path}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemText primary={page.label} />
              </ListItem>
            ) : (
              <ListItem
                button
                key={page.label}
                component={NavLink}
                to={page.path}
                sx={{
                  "&.active .MuiListItemText-root": {
                    color: "#124178",
                    fontWeight: "bold",
                  },
                }}
              >
                <ListItemText primary={page.label} />
              </ListItem>
            )
          )}
        </List>
      </Box>
    </Drawer>
  );

  return (
    <>
      <AppBar
        position="static"
        sx={{
          bgcolor: "#fff",
          height: "80px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          justifyContent: "center",
        }}
      >
        <Toolbar
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 1, sm: 3, md: 5 },
            minHeight: "80px !important",
          }}
        >
          {/* Logo and Menu Icon */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {isMobile && (
              <IconButton
                edge="start"
                onClick={toggleDrawer(true)}
                sx={{ color: "#124178", p: 0 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <a
              href="https://dreamdor.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center" }}
            >
              <img
                src="/assets/logo/image.png"
                alt="Logo"
                style={{
                  height: 55,
                  objectFit: "contain",
                  marginTop: "2px",
                }}
              />
            </a>
          </Box>

          {/* Navigation Links */}
          {!isMobile && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
              {pages.map((page) =>
                page.external ? (
                  <Button
                    key={page.label}
                    component="a"
                    href={page.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#124178",
                      fontSize: "16px",
                      textTransform: "none",
                      p: 0,
                      minWidth: "auto",
                    }}
                  >
                    {page.label}
                  </Button>
                ) : (
                  <Button
                    key={page.label}
                    component={NavLink}
                    to={page.path}
                    sx={{
                      color: "#124178",
                      fontSize: "16px",
                      textTransform: "none",
                      p: 0,
                      minWidth: "auto",
                      "&.active": {
                        fontWeight: "bold",
                        // borderBottom: "2px solid #124178",
                      },
                    }}
                  >
                    {page.label}
                  </Button>
                )
              )}
            </Box>
          )}
        </Toolbar>
      </AppBar>
      {drawer}
    </>
  );
}

// import React from "react";
// import { NavLink } from "react-router-dom";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Button from "@mui/material/Button";
// import Drawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";

// const pages = [
//   { label: "Home", path: "/" },
//   { label: "Blog", path: "/blog" },
// ];

// export default function BlogNavbar() {
//   const [drawerOpen, setDrawerOpen] = React.useState(false);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const toggleDrawer = (open) => () => {
//     setDrawerOpen(open);
//   };

//   const drawer = (
//     <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//       <Box
//         sx={{ width: 250 }}
//         role="presentation"
//         onClick={toggleDrawer(false)}
//         onKeyDown={toggleDrawer(false)}
//       >
//         <List>
//           {pages.map((page) => (
//             <ListItem
//               button
//               key={page.label}
//               component={NavLink}
//               to={page.path}
//               sx={{
//                 "&.active .MuiListItemText-root": {
//                   color: "#124178",
//                   fontWeight: "bold",
//                 },
//               }}
//             >
//               <ListItemText primary={page.label} />
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Drawer>
//   );

//   return (
//     <>
//       <AppBar
//         position="static"
//         sx={{
//           bgcolor: "#fff",
//           height: "80px",
//           boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//           justifyContent: "center",
//         }}
//       >
//         <Toolbar
//           sx={{
//             height: "100%",
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             px: { xs: 1, sm: 3, md: 5 },
//             minHeight: "80px !important", // fix for MUI default minHeight
//           }}
//         >
//           {/* Logo and Menu Icon */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             {isMobile && (
//               <IconButton
//                 edge="start"
//                 onClick={toggleDrawer(true)}
//                 sx={{ color: "#124178", p: 0 }}
//               >
//                 <MenuIcon />
//               </IconButton>
//             )}
//             <a
//               href="https://dreamdor.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <img
//                 src="/assets/logo/image.png"
//                 alt="Logo"
//                 style={{ height: 55, objectFit: "contain", marginTop: "2px" }}
//               />
//             </a>

//             {/* <NavLink
//               to="dreamdor.com"
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <img
//                 src="/assets/logo/image.png"
//                 alt="Logo"
//                 style={{
//                   height: 55,
//                   objectFit: "contain",
//                   marginTop: "2px",
//                 }}
//               />
//             </NavLink> */}
//           </Box>

//           {/* Navigation Links */}
//           {!isMobile && (
//             <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
//               {pages.map((page) => (
//                 <Button
//                   key={page.label}
//                   component={NavLink}
//                   to={page.path}
//                   sx={{
//                     color: "#124178",
//                     fontSize: "16px",
//                     textTransform: "none",
//                     p: 0,
//                     minWidth: "auto",
//                     "&.active": {
//                       fontWeight: "bold",
//                       borderBottom: "2px solid #124178",
//                     },
//                   }}
//                 >
//                   {page.label}
//                 </Button>
//               ))}
//             </Box>
//           )}
//         </Toolbar>
//       </AppBar>
//       {drawer}
//     </>
//   );
// }

// import React from "react";
// import { NavLink } from "react-router-dom";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Button from "@mui/material/Button";
// import Drawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";

// const pages = [
//   { label: "Home", path: "/" },
//   { label: "Blog", path: "/blog" },
// ];

// export default function BlogNavbar() {
//   const [drawerOpen, setDrawerOpen] = React.useState(false);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const toggleDrawer = (open) => () => {
//     setDrawerOpen(open);
//   };

//   const drawer = (
//     <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//       <Box
//         sx={{ width: 250 }}
//         role="presentation"
//         onClick={toggleDrawer(false)}
//         onKeyDown={toggleDrawer(false)}
//       >
//         <List>
//           {pages.map((page) => (
//             <ListItem
//               button
//               key={page.label}
//               component={NavLink}
//               to={page.path}
//               sx={{
//                 "&.active .MuiListItemText-root": {
//                   color: "#124178",
//                   fontWeight: "bold",
//                 },
//               }}
//             >
//               <ListItemText primary={page.label} />
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Drawer>
//   );

//   return (
//     <>
//       <AppBar
//         position="static"
//         sx={{
//           bgcolor: "#fff",
//           height: "80px", // Ensure consistent AppBar height
//           justifyContent: "center", // Vertically center Toolbar
//           boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//         }}
//       >
//         <Toolbar
//           disableGutters
//           sx={{
//             px: 2,
//             minHeight: "80px !important", // Ensure Toolbar matches AppBar height
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           {/* Logo and Menu Icon */}
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             {isMobile && (
//               <IconButton
//                 edge="start"
//                 onClick={toggleDrawer(true)}
//                 sx={{ color: "#124178", mr: 1 }}
//               >
//                 <MenuIcon fontSize="medium" />
//               </IconButton>
//             )}
//             <NavLink to="/" style={{ display: "inline-block" }}>
//               <img
//                 src="/assets/logo/image.png"
//                 alt="Logo"
//                 style={{
//                   height: 48, // Reduced for better vertical fit
//                   display: "inline-block",
//                 }}
//               />
//             </NavLink>
//           </Box>

//           {/* Desktop Navigation Links */}
//           {!isMobile && (
//             <Box sx={{ display: "flex", gap: 3 }}>
//               {pages.map((page) => (
//                 <Button
//                   key={page.label}
//                   component={NavLink}
//                   to={page.path}
//                   sx={{
//                     color: "#124178",
//                     fontSize: "18px",
//                     textTransform: "none",
//                     "&.active": {
//                       color: "#124178",
//                       fontWeight: "bold",
//                       borderBottom: "2px solid #124178",
//                     },
//                   }}
//                 >
//                   {page.label}
//                 </Button>
//               ))}
//             </Box>
//           )}
//         </Toolbar>
//       </AppBar>
//       {drawer}
//     </>
//   );
// }

// import React from "react";
// import { NavLink } from "react-router-dom";
// import AppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import Toolbar from "@mui/material/Toolbar";
// import IconButton from "@mui/material/IconButton";
// import MenuIcon from "@mui/icons-material/Menu";
// import Button from "@mui/material/Button";
// import Drawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import { useTheme } from "@mui/material/styles";

// const pages = [
//   { label: "Home", path: "/" },
//   { label: "Blog", path: "/blog" },
// ];

// export default function BlogNavbar() {
//   const [drawerOpen, setDrawerOpen] = React.useState(false);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const toggleDrawer = (open) => () => {
//     setDrawerOpen(open);
//   };

//   const drawer = (
//     <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//       <Box
//         sx={{ width: 250 }}
//         role="presentation"
//         onClick={toggleDrawer(false)}
//       >
//         <List>
//           {pages.map((page) => (
//             <ListItem
//               button
//               key={page.label}
//               component={NavLink}
//               to={page.path}
//               sx={{
//                 "&.active .MuiListItemText-root": {
//                   color: "#124178",
//                   fontWeight: "bold",
//                 },
//               }}
//             >
//               <ListItemText primary={page.label} />
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Drawer>
//   );

//   return (
//     <>
//       <AppBar
//         position="static"
//         sx={{
//           bgcolor: "#fff",
//           height: "80px", // consistent height
//           boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//         }}
//       >
//         <Toolbar
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             height: "100%",
//             px: 2,
//           }}
//         >
//           {/* Logo and Menu Icon */}
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             {isMobile && (
//               <IconButton
//                 edge="start"
//                 onClick={toggleDrawer(true)}
//                 sx={{ color: "#124178", mr: 1 }}
//               >
//                 <MenuIcon />
//               </IconButton>
//             )}
//             <NavLink to="/" style={{ display: "inline-block" }}>
//               <img
//                 src="/assets/logo/image.png"
//                 alt="Logo"
//                 style={{
//                   height: 60,
//                   display: "inline-block",
//                   verticalAlign: "middle",
//                 }}
//               />
//             </NavLink>
//           </Box>

//           {/* Navigation Links */}
//           {!isMobile && (
//             <Box sx={{ display: "flex", gap: 2 }}>
//               {pages.map((page) => (
//                 <Button
//                   key={page.label}
//                   component={NavLink}
//                   to={page.path}
//                   sx={{
//                     color: "#124178",
//                     fontSize: "18px",
//                     textTransform: "none",
//                     "&.active": {
//                       color: "#124178",
//                       fontWeight: "bold",
//                       borderBottom: "2px solid #124178",
//                     },
//                   }}
//                 >
//                   {page.label}
//                 </Button>
//               ))}
//             </Box>
//           )}
//         </Toolbar>
//       </AppBar>
//       {drawer}
//     </>
//   );
// }
